import * as React from 'react';
export default function TabScreen(_ref) {
  let {
    children
  } = _ref;
  return React.Children.only(children);
}
//# sourceMappingURL=TabScreen.js.map